import moment from 'moment'

export const getBeaconTimestamp = (record = {}) => {
  const ts = record.timestamp || record.tts || record.incoming_time || record.time || record.createdAt
  const numeric = Number(ts)
  return numeric && !Number.isNaN(numeric) ? numeric : ts
}

export const getBeaconDeviceId = (record = {}) => {
  return record.deviceId || record.deviceid || record.device_id || record.imei || record.detectedBy || '-'
}

export const getBeaconRssi = (record = {}) => {
  const candidates = [record.rssi, record.rssiValue, record.rsi, record.RSSI, record.RSI]
  const value = candidates.find(item => item !== undefined && item !== null && item !== '')
  return value !== undefined && value !== null && value !== '' ? value : '-'
}

export const getBeaconMac = (record = {}) => {
  return record.instanceId || record.instanceid || record.instancsid || record.mac || record.instance_id || '-'
}

export const getBeaconLatLong = (record = {}) => {
  if (record.lat_long && typeof record.lat_long === 'string') {
    const parts = record.lat_long.split(',').map(item => parseFloat((item || '').trim()))
    if (parts.length === 2 && isValidCoordinate(parts[0], parts[1])) return parts
  }

  if (record.latlng && typeof record.latlng === 'string') {
    const parts = record.latlng.split(',').map(item => parseFloat((item || '').trim()))
    if (parts.length === 2 && isValidCoordinate(parts[0], parts[1])) return parts
  }

  const lat = record.lat || record.latitude
  const lng = record.lng || record.long || record.longitude
  if (isValidCoordinate(lat, lng)) {
    return [parseFloat(lat), parseFloat(lng)]
  }

  return null
}

export const formatBeaconLatLong = (record = {}) => {
  const latLong = getBeaconLatLong(record)
  return latLong ? `${latLong[0]}, ${latLong[1]}` : '-'
}

export const isValidCoordinate = (lat, lng) => {
  const parsedLat = parseFloat(lat)
  const parsedLng = parseFloat(lng)
  return !Number.isNaN(parsedLat)
    && !Number.isNaN(parsedLng)
    && parsedLat !== 0
    && parsedLng !== 0
    && parsedLat >= -90
    && parsedLat <= 90
    && parsedLng >= -180
    && parsedLng <= 180
}

export const sortBeaconData = (data = []) => {
  return [...(data || [])].sort((a, b) => {
    const at = Number(getBeaconTimestamp(a)) || 0
    const bt = Number(getBeaconTimestamp(b)) || 0
    return at - bt
  })
}

export const getBeaconStatus = (record = {}) => {
  if (record.status) return record.status

  const timestamp = getBeaconTimestamp(record)
  const timeDifference = timestamp ? moment().diff(moment(timestamp), 'seconds') : null
  if (timeDifference !== null && Math.abs(timeDifference) <= 300) return 'online'
  if (timestamp) return 'offline'

  return '-'
}

export const getLatestBeaconRecord = (data = []) => {
  const sorted = sortBeaconData(data)
  return sorted.length ? sorted[sorted.length - 1] : null
}

export const getBleTagAsset = (asset = {}, mac) => {
  const dependents = asset && asset.dependents && asset.dependents.length ? asset.dependents : []
  const normalizedMac = (mac || '').toString().toLowerCase()
  return dependents.find(item => {
    const itemMac = item && item.bleTagId ? item.bleTagId.toString().toLowerCase() : ''
    return item
      && item.assetModel
      && item.assetModel.isBleTag
      && item.bleTagId
      && (!normalizedMac || itemMac === normalizedMac)
  })
}
